// Small square images (pixel-art tiles): repeated across the frame's picture opening, pixels kept sharp.
//
// An image counts as a tile when its aspect is within TILE_ASPECT_TOL of 1:1 and its long side is at most TILE_MAX_PX.
// On the wall a tile is TILE_PX_M per image pixel, clamped to TILE_MIN_M..TILE_MAX_M; the tile size is then adjusted so
// a whole number of tiles fills the opening's width. Vertically one tile is centred and the partial tiles at the top
// and bottom are equal. The panel preview uses the same layout (CSS background).

export const TILE_MAX_PX = 256;
export const TILE_ASPECT_TOL = 0.02;
/** On-wall size of one image pixel of a tile (m), and the limits of a tile's side. */
export const TILE_PX_M = 0.002;
export const TILE_MIN_M = 0.06;
export const TILE_MAX_M = 0.16;

export const isTile = (w: number, h: number): boolean => w > 0 && h > 0 && Math.max(w, h) <= TILE_MAX_PX && Math.abs(w / h - 1) <= TILE_ASPECT_TOL;

/**
 * The tiling of a `px`-pixel tile over an opening of `w` x `h` metres: repeats across and down (texture repeat) and the
 * offsets (texture offset, v up), so tile edges meet the left and right edges and one tile is centred vertically.
 */
export function tileLayout(px: number, w: number, h: number): { rx: number; ry: number; ox: number; oy: number; side: number } {
  const want = Math.min(TILE_MAX_M, Math.max(TILE_MIN_M, px * TILE_PX_M));
  const rx = Math.max(1, Math.round(w / want));
  const side = w / rx;
  const ry = h / side;
  return { rx, ry, ox: 0, oy: 0.5 - 0.5 * ry, side };
}
